export function initNavigation() {
  const navLinks = document.querySelectorAll('.nav-link');
  const sections = document.querySelectorAll('.section[id]');
  const progressFill = document.getElementById('scroll-progress-fill');
  const progressPercent = document.getElementById('scroll-progress-percent');
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const sidebar = document.getElementById('sidebar');
  const drawerOverlay = document.getElementById('mobile-drawer-overlay');

  // Update scroll percentage indicator
  function updateScrollProgress() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    
    let progress = 0;
    if (scrollHeight > 0) {
      progress = Math.min(100, Math.max(0, Math.round((scrollTop / scrollHeight) * 100)));
    }

    if (progressFill) progressFill.style.width = `${progress}%`;
    if (progressPercent) progressPercent.textContent = `${progress}%`;
  }

  // Highlight active section based on scroll position
  function highlightActiveNav() {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;

    sections.forEach(section => {
      const sectionTop = section.offsetTop - 120;
      const sectionHeight = section.offsetHeight;
      const sectionId = section.getAttribute('id');

      if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
        navLinks.forEach(link => {
          link.classList.remove('active');
          if (link.getAttribute('href') === `#${sectionId}`) {
            link.classList.add('active');
          }
        });
      }
    });
  }

  // Scroll listener
  window.addEventListener('scroll', () => {
    updateScrollProgress();
    highlightActiveNav();
  }, { passive: true });

  // Initial call
  updateScrollProgress();
  highlightActiveNav();

  // Mobile Menu Drawer Handler
  function toggleMobileMenu(open) {
    const isOpen = open !== undefined ? open : !sidebar.classList.contains('open');
    if (sidebar) sidebar.classList.toggle('open', isOpen);
    if (mobileToggle) mobileToggle.classList.toggle('open', isOpen);
    if (drawerOverlay) drawerOverlay.classList.toggle('open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => toggleMobileMenu());
  }

  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', () => toggleMobileMenu(false));
  }

  // Close drawer when link clicked on mobile
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href');
      if (targetId.startsWith('#')) {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({ behavior: 'smooth' });
          toggleMobileMenu(false);
        }
      }
    });
  });
}
